import { render, staticRenderFns } from "./paymentTerms.vue?vue&type=template&id=4d596c50&scoped=true&"
import script from "./paymentTerms.vue?vue&type=script&lang=js&"
export * from "./paymentTerms.vue?vue&type=script&lang=js&"
import style0 from "./paymentTerms.vue?vue&type=style&index=0&id=4d596c50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d596c50",
  null
  
)

export default component.exports